// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import IncomeTaxRateInput from '../income-tax-rate';

const IncomeTaxRateInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <IncomeTaxRateInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default IncomeTaxRateInputWithAnalytics;
